import Button from 'components/button';
import React from 'react';
import { styleCell, styleInput, styleRow, styleTable } from '../../styles';

interface IPropsDictionaryTable {
    inpObj: any;
    typeKey?: string;
    typeValue?: string;
    closeCB?: Function;
    saveCB?: Function;
}
export const DictionaryTable: React.FC<IPropsDictionaryTable> = ({ inpObj, typeKey, typeValue, closeCB, saveCB }) => {
    let [editObj, setEditObj] = React.useState({ ...inpObj });

    const addParam = (key: string) => {
        if (editObj[key] === undefined && key !== '') {
            editObj[key] = '';
            setEditObj(Object.assign({}, editObj));
        }
    };
    const editParam = (key: string, value: string) => {
        if (editObj[key] !== undefined) {
            editObj[key] = value;
            setEditObj(Object.assign({}, editObj));
        }
    };
    const delParam = (key: string) => {
        if (editObj[key] !== undefined) {
            delete editObj[key];
            setEditObj(Object.assign({}, editObj));
        }
    };
    const filteringByType = (inStr: string, selectedTypeKey: boolean) => {
        let outStr: string = '';
        let type = selectedTypeKey ? typeKey : typeValue;
        switch (type) {
            case 'System.String': {
                outStr = inStr;
                break;
            }
            case 'System.Single': {
                outStr = inStr.replace(/[^0-9.s\-]/g, '').replace(/(\..*)\./g, '$1');
                break;
            }
            case 'System.Int32': {
                outStr = inStr.replace(/[^0-9\-]/g, '');
                break;
            }
        }

        return outStr;
    };

    const genTable = () => {
        let arrTr = [];
        for (let key in editObj) {
            arrTr.push(
                <tr style={styleRow}>
                    <td style={styleCell}>{key}</td>
                    <td style={styleCell}>
                        <input
                            key={key}
                            style={styleInput}
                            defaultValue={editObj[key]}
                            onChange={(e) => {
                                editParam(key, e.target.value);
                            }}
                            onInput={(e) => {
                                e.currentTarget.value = filteringByType(e.currentTarget.value, false);
                            }}
                        />
                    </td>
                    <td style={styleCell} onClick={() => delParam(key)}>
                        X
                    </td>
                </tr>
            );
        }
        arrTr.push(
            <tr style={styleRow}>
                <td style={styleCell}>
                    <input
                        key={'addInpKey'}
                        style={styleInput}
                        onBlur={(e) => {
                            addParam(e.target.value);
                        }}
                        onInput={(e) => {
                            e.currentTarget.value = filteringByType(e.currentTarget.value, true);
                        }}
                    />
                </td>
                <td style={styleCell}>
                    <input key={'addInpValue'} style={styleInput} disabled />
                </td>
            </tr>
        );
        return arrTr;
    };
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }} /*onClick={() => closeCB && closeCB()}*/
        >
            <div
                style={{
                    background: 'white',
                    padding: '1em',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}>
                <div style={{ overflow: 'auto' }}>
                    <table style={styleTable}>{genTable()}</table>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button text="Сохранить" width={100} height={24} onClick={() => saveCB && saveCB(editObj)} />
                    <div style={{ width: '1em' }}></div>
                    <Button text="Отмена" width={100} height={24} filled onClick={() => closeCB && closeCB()} />
                </div>
            </div>
        </div>
    );
};
